module.exports = __webpack_public_path__ + "img/greyoutlinewhatsapp.fe98d950.svg";